import { Model } from 'core/model';

export default class CloudConnectivityReport extends Model {
  get urlRoot() {
    return '/api/ui/cloudConnectivityReport';
  }
}
